<template>
    <BreadCrumb PageTitle="Liste des Groupe de taxe" />
    <ListeGroupeTaxe />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeGroupeTaxe from "../../components/GroupeTaxe/ListeGroupeTaxe.vue";
  
  export default defineComponent({
    name: "ListeGroupeTaxePage",
    components: {
      BreadCrumb,
      ListeGroupeTaxe,
    },
  });
  </script>